export const SHOW_ABAD = 'showAbad';
export const SYNTHETIC_TEST_INDICATOR = 'syntheticTest';
export const QUERY_PARAMETER_MANAGER_STORAGE_KEY = 'zhl-query-parameters';

export const EXCESS_AMPERSAND_REGEX = /&(?!\w)/g;
